"use client";

import { Config, Template } from "src/types";
import { componentMapDynamic, Page } from "../../SelectedTemplateComponent";
import { mockConfig } from "../../constants/mockConfig";
import { useTheme } from "../../contexts/useTheme";

type GeneralSwitchProps = {
  path: Page;
  serverConfig?: Config;
};

const GeneralSwitch: React.FC<GeneralSwitchProps> = ({
  path,
  serverConfig,
}) => {
  const { config } = useTheme();
  const isDemoMode = process.env.NEXT_PUBLIC_DEMO_MODE === "true";

  const template: Template =
    (isDemoMode ? config?.template : serverConfig?.template) ?? "design1";

  const SelectedComponent = componentMapDynamic[path][template] || componentMapDynamic[path]["design1"];

  return <SelectedComponent styling={mockConfig.styling} />;
};

export default GeneralSwitch;
